<template>
  <div class="switch-container d-flex justify-center align-center">
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <div
          v-on="on"
          class="mr-1 px-3 d-flex"
          :class="{ 'option-active': !isKanbanViewActive }"
          @click="$emit('change', $constants.TASKS_VIEW_OPTIONS.list)"
        >
          <v-icon size="12" color="blue-grey darken-1"
            >mdi-format-list-bulleted</v-icon
          >
        </div>
      </template>
      {{ $t('common.view_as_list') }}
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <div
          v-on="on"
          class="px-3 d-flex"
          :class="{ 'option-active': isKanbanViewActive }"
          @click="$emit('change', $constants.TASKS_VIEW_OPTIONS.kanban)"
        >
          <v-icon size="12" color="blue-grey darken-1"
            >mdi-view-column-outline</v-icon
          >
        </div>
      </template>
      {{ $t('common.view_as_kanban') }}
    </v-tooltip>
  </div>
</template>
<script>
export default {
  name: 'ViewSwitch',

  computed: {
    isKanbanViewActive() {
      return (
        this.$route.query.viewType === this.$constants.TASKS_VIEW_OPTIONS.kanban
      )
    },
  },
}
</script>

<style scoped lang="scss">
.switch-container {
  border: 1px solid $color-blue-grey-lighten1;
  border-radius: 12px;
  padding: 2px;
  height: 24px;
  cursor: pointer;
}
.option-active {
  background-color: $color-blue-grey-lighten3;
  height: 20px;
  border-radius: 10px;
}
</style>
